/** @format */
import { createMachine } from 'xstate';

export enum SignUpMachineAction {
    SUBMIT = 'submit',
}

export enum SignUpMachineState {
    FORM = 'form',
    NEARLY_THERE = 'nearly-there',
}

export const signUpMachine = createMachine({
    predictableActionArguments: true,
    id: 'sign-up-machine',
    initial: SignUpMachineState.FORM,
    states: {
        [SignUpMachineState.FORM]: {
            on: {
                [SignUpMachineAction.SUBMIT]: SignUpMachineState.NEARLY_THERE,
            },
        },
        [SignUpMachineState.NEARLY_THERE]: {},
    },
});
